export const set_notification_type = (notificationType) => ({
  type: 'set_notification_type',
  payload: notificationType,
});
